import { ReactElement } from 'react';
import usePendoTracking from 'customHooks/usePendoTracking';
import AsyncSelect from 'lib/AsyncSelect';
import { SelectHandler } from 'lib/AsyncSelect/AsyncSelect.types';
import { CodeNameModel } from 'components/common/types';
import { FilterAsyncLookupProps } from './FilterAsyncLookup.types';

const FilterAsyncLookup = <TFilterModel extends Record<string, CodeNameModel>>({
  filterKey,
  selectedValue,
  loadData,
  changeFilters,
  placeholder,
  dataTestId,
  pendoLabel,
  ...asyncSelectProps
}: FilterAsyncLookupProps<TFilterModel>): ReactElement => {
  const { getPendoDataId } = usePendoTracking(window.location.pathname);

  const handleSelect: SelectHandler<CodeNameModel> = (_, value: CodeNameModel): void => {
    changeFilters({ [filterKey]: value } as Partial<TFilterModel>);
  };

  return (
    <AsyncSelect
      name={filterKey}
      selectedValue={selectedValue}
      loadData={loadData}
      onSelect={handleSelect}
      placeholder={placeholder}
      dataTestId={dataTestId}
      textKey="name"
      dataPendoId={getPendoDataId(pendoLabel)}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...asyncSelectProps}
    />
  );
};

export default FilterAsyncLookup;
